import React, { useState, useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { Link } from 'react-router-dom';

const ProjectNav = () => {
  const [isOpen, setIsOpen] = useState(false);
  const controls = useAnimation();

  useEffect(() => {
    controls.start({ opacity: 1, x: 0, transition: { duration: 1 } });
  }, [controls]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
   
  };
  
  const closeMenu = (e) => {
    e.stopPropagation();
    setIsOpen(false);
    
  };

  const variants = {
    open: {
      opacity: 1,
      width: '100%',
      transition: {
        duration: 0.3,
      },
    },
    closed: {
      opacity: 0,
      width: '0',
    },
  };

  const menuVariants = {
    open: {
      display: 'block',
      transition: {
        staggerChildren: 0.07,
        delayChildren: 0.2,
      },
    },
    closed: {
      display: 'none',
    },
  };

  const menuItemVariants = {
    open: {
      opacity: 1,
      x: 0,
    },
    closed: {
      opacity: 0,
      x: '-50%',
    },
  };

  const menuItems = [
    { label: 'Home', link: '/' },
    { label: 'Works', link: '/works' },
    { label: 'About', link: '/services' },
    { label: 'Stack', link: '/contact' },
   
  ];

  return (
    <header className="bg-transparent w-full">
      <nav className="mx-auto flex items-center justify-between p-4 lg:px-8 text-white" aria-label="Global">
        <motion.h1 initial={{ opacity: 0, x: -50 }} animate={controls} className='title-p font-normal text-white text-2xl hover:animate-pulse cursor-pointer'>
         <Link to='/'> [Back]</Link>
        </motion.h1>
        <div>
          <button onClick={toggleMenu} className="text-white ">
            {isOpen ? (
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-14 w-14">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="0.8" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            ) : (
              <motion.p  className='title-p font-bold text-white text-2xl hover:animate-pulse'>
                MENU
              </motion.p>
            )}
          </button>
        </div>
      </nav>
      <motion.div
        initial="closed"
        animate={isOpen ? 'open' : 'closed'}
        variants={variants}
        className={`fixed top-0 left-0 w-full h-full  bg-black text-white  z-20 ${isOpen ? 'w-full' : 'w-0'}`}
        style={{
            overflowX: isOpen ? 'hidden' : 'auto',
            overflowY: isOpen ? 'auto' : 'hidden',
          }}
      >
        <button onClick={closeMenu} className="absolute top-4 right-4 text-white mb-9">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="md:h-14 md:w-14 h-8 w-8">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="0.8" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
        <motion.ul variants={menuVariants} className="text-center flex justify-center py-24">
          {menuItems.map((item, index) => (
            <motion.li initial={{ opacity: 0, x: -50 }} animate={controls} key={index} variants={menuItemVariants} className="mb-4">
              <Link to={item.link} className="text-white hover:text-indigo-600 md:text-[120px] text-[90px] port-links">
                {item.label}
              </Link>
            </motion.li>
          ))}
        </motion.ul>
        <div className="">
        <ul className=' flex justify-center items-center'>
          <li className=''>
            <a href="#home" className=' text-white footer-links flex justify-between items-center hover:animate-pulse '>
              <span className=' md:text-[23px] mr-2'>LINKEDIN</span>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="white" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25" />
              </svg>

            </a>
          </li>
          <li className=' ml-3'>
            <a href="#home" className=' text-white footer-links flex justify-between items-center hover:animate-pulse'>
              <span className='md:text-[23px]  mr-2'>TWITTER</span>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="white" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25" />
              </svg>

            </a>
          </li>
          <li className=' ml-3'>
            <a href="#home" className=' text-white footer-links flex justify-between items-center  hover:animate-pulse'>
              <span className='md:text-[23px]  mr-2'>INSTAGRAM</span>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="white" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25" />
              </svg>

            </a>
          </li>
        </ul>
      </div>
      </motion.div>
    </header>
  );
};

export default ProjectNav;
